<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 200px; margin-right: 20px"
          v-model="yearmonth"
          @on-change="changeDate"
        />
        <Select v-model="mode" style="width:200px" @on-change="changeMode">
          <Option v-for="item in modeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <Button
          type="success"
          style="margin-right: 20px"
          :loading="exportTechStatLoading"
          @click="exportTechStatMethod()"
        >导出数据</Button>
        <!-- <span>共{{ totalRows }}条</span> -->
        <!-- <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadBankAccount"
          show-total
          simple
          style="margin-right: 24px"
        /> -->
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        border
        :data="techServicesStat"
        :height="tableHeight"
      >
      </Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import axios from "@/utils/axios";

export default {
  name: "TechServiceStatPage",
  data() {
    return {
      tableHeight: 300,
      filterQuery: {},
      mode: 'customer',
      yearmonth: dayjs().format("YYYY-M"),
      tableLoading: false,
      exportTechStatLoading: false,
      page: 0,
      limit: 20,
      columns: [
        {
          title: "技术人员",
          key: "name",
          minWidth: 140,
          render: (h, params) => h("span", params.row.customer ? params.row.customer.name : params.row.name),
        },
        {
          title: "工单次数",
          key: "conut",
          minWidth: 80,
          align: "center",
          render: (h, params) => h("span", params.row.tsCounts),
        },
      ],
      modeList: [
        {
            value: 'customer',
            label: '按客户统计'
        },
        {
            value: 'technology',
            label: '按技术人员统计'
        }
      ],
      dateArray: [],
    };
  },
  computed: mapState({
    techServicesStat: (state) => state.technicalService.techServicesStat,
  }),
  methods: {
    ...mapActions({
      getTechServiceStat: "technicalService/getTechServiceStatction",
    }),
    async loadTechServiceStat(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 15,
        yearmonth: this.yearmonth,
        mode: this.mode
      };
      try {
        this.tableLoading = true;
        await this.getTechServiceStat(this.filterQuery);
        this.columns[0].title = this.mode === 'customer'?'客户':"技术人员"
        this.tableLoading = false;
        for (let i = 0; i < this.dateArray.length; i++) {
          let date = {};
          date.key = `date${i}`;
          date.minWidth = 40;
          date.align = "right";
          date.renderHeader = (h, params) => {
            return h("div", this.dateArray[i]);
          };
          date.render = (h, params) => {
            params.row[`${this.dateArray[i]}count`] = 0;
            for (let j = 0; j < params.row.ts.length; j++) {
              if (params.row.ts[j].date == this.dateArray[i]) {
                params.row[`${this.dateArray[i]}count`] =
                  params.row[`${this.dateArray[i]}count`] + 1;
              }
            }

            return h(
              "div",
              {
                style: {
                  color:
                    params.row[`${this.dateArray[i]}count`] == 0
                      ? "lightgray"
                      : "black",
                },
              },
              params.row[`${this.dateArray[i]}count`]
            );
          };
          this.columns.push(date);
        }
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    changeDate(e) {
      this.dateArray = [];
      this.columns.splice(2, this.columns.length - 2);
      this.filterQuery.yearmonth = dayjs(e).format("YYYY-M");
      const date = new Date(this.filterQuery.yearmonth);
      const startDate = dayjs(new Date(date.getFullYear(), date.getMonth(), 1));
      const endDate = dayjs(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      );
      this.calcDaysCount(startDate, endDate);
      this.loadTechServiceStat();
    },
    async changeMode(mode) {
      this.dateArray = [];
      this.columns.splice(2, this.columns.length - 2);
      let date = new Date(this.filterQuery.yearmonth);
      const startDate = dayjs(new Date(date.getFullYear(), date.getMonth(), 1));
      const endDate = dayjs(
        new Date(date.getFullYear(), date.getMonth() + 1, 0)
      );
      this.calcDaysCount(startDate, endDate);
      await this.loadTechServiceStat();
    },
    calcDaysCount(start, end) {
      const daysCount = end.diff(start, "day") + 1;
      for (let i = 0; i < daysCount; i++) {
        const currentDate = start.add(i, "day");
        this.dateArray.push(dayjs(currentDate).format("M/D"));
      }
    },
    async exportTechStatMethod() {
      this.exportTechStatLoading = true;
      try {
        const res = await axios.get(`/export_service_stat`, {
          responseType: "blob",
          params: { 
            yearmonth: this.yearmonth,
            mode: this.mode 
          },
        });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `技术统计${dayjs().format("MM-DD-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        this.exportTechStatLoading = false;
      } catch (error) {
        this.$Message.error({
          content: error,
          duration: 10,
          closable: true
        });
        this.exportTechStatLoading = false;
      }
    },
  },
  async created() {
    let date = new Date();
    const startDate = dayjs(dayjs(new Date().setDate(1)).format("YYYY-MM-DD"));
    const endDate = dayjs(new Date(date.getFullYear(), date.getMonth() + 1, 0));
    this.calcDaysCount(startDate, endDate);
    await this.loadTechServiceStat();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>